/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext, Dispatch, SetStateAction } from 'react';

interface Empresa {
  cd: string;
  cd_empresa: string;
  nm: string;
}

interface ComboBoxProps {
  empresa: Empresa[];
  cdEmpresa: number;
  setCdEmpresa: Dispatch<SetStateAction<number>>;
  setEmpresa: Dispatch<SetStateAction<Empresa[]>>;
}

export const ComboBoxContext = createContext<ComboBoxProps>({
  empresa: [
    {
      cd: '',
      cd_empresa: '',
      nm: '',
    },
  ],
  cdEmpresa: 0,
  setCdEmpresa: () => { },
  setEmpresa: () => { },
});
